import { useEffect, useMemo } from 'react';
import { Outlet } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import AppBar from '@mui/material/AppBar';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import GlobalStyles from '@mui/material/GlobalStyles';

// project imports
import Footer from './Footer';
import Header from './Header';
import Sidebar from './Sidebar';
import useAppSettings from 'hooks/useAppSettings';
import HorizontalBar from './HorizontalBar';
import MainContentStyled from './MainContentStyled';
// import Customization from '../Customization';
import Loader from 'ui-component/Loader';
import Breadcrumbs from 'ui-component/extended/Breadcrumbs';

import { MenuOrientation } from 'config';
import useConfig from 'hooks/useConfig';
import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';
import { useSidebarPeek } from './Sidebar/peek';

// ==============================|| MAIN LAYOUT ||============================== //

export default function MainLayout() {
  const theme = useTheme();
  const downMD = useMediaQuery(theme.breakpoints.down('md'));
  const appSettings = useAppSettings();

  const {
    state: { borderRadius, container, miniDrawer, menuOrientation }
  } = useConfig();
  const { menuMaster, menuMasterLoading } = useGetMenuMaster();
  const drawerOpen = menuMaster?.isDashboardDrawerOpened;
  const sidebarPeek = useSidebarPeek(); // aberto só pelo mouse: o conteúdo fica onde está

  // Estado inicial do menu lateral é decidido no Header (opção 'Menu lateral: iniciar aberto').

  useEffect(() => {
    downMD && handlerDrawerOpen(false);
  }, [downMD]);

  const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downMD;

  // horizontal menu-list bar : drawer
  const menu = useMemo(() => (isHorizontal ? <HorizontalBar /> : <Sidebar />), [isHorizontal]);

  if (menuMasterLoading) return <Loader />;

  return (
    <Box sx={{ display: 'flex' }}>
      {appSettings?.sidebar_grad_color ? (
        <GlobalStyles
          styles={{
            '.MuiDrawer-paper, [data-simplebar="init"], [data-simplebar="init"] > div': {
              background: `linear-gradient(135deg, ${appSettings.sidebar_grad_color}, ${appSettings.sidebar_grad_color_back || appSettings.sidebar_grad_color}) !important`,
            },
          }}
        />
      ) : null}
      {appSettings?.sidebar_active_bg_color ? (
        <GlobalStyles
          styles={{
            'nav .MuiListItemButton-root.Mui-selected, nav .MuiListItemButton-root.Mui-selected:hover': {
              backgroundColor: `${appSettings.sidebar_active_bg_color} !important`,
            },
          }}
        />
      ) : null}
      {/* header */}
      <AppBar enableColorOnDark position="fixed" color="inherit" elevation={0} sx={{ bgcolor: 'background.default' }}>
        <Toolbar
          sx={{
            background: appSettings?.navbar_grad_color
              ? `linear-gradient(135deg, ${appSettings.navbar_grad_color}, ${appSettings.navbar_grad_color_back || appSettings.navbar_grad_color})`
              : 'linear-gradient(135deg, rgb(0,206,209), rgb(0,250,154))',
            color: appSettings?.navbar_font_color || undefined,
            '& .MuiSvgIcon-root, & .MuiTypography-root, & .MuiButton-root, & .MuiIconButton-root': {
              color: appSettings?.navbar_font_color || undefined,
            },
            p: isHorizontal ? 1.25 : 2,
          }}
        >
          <Header />
        </Toolbar>
      </AppBar>

      {/* menu / drawer */}
      {menu}

      {/* main content */}
      <MainContentStyled {...{ borderRadius, menuOrientation, open: drawerOpen && !sidebarPeek }}>
        <Container
          maxWidth={false}
          sx={{ ...(!container && { px: { xs: 0 } }), minHeight: 'calc(100vh - 128px)', display: 'flex', flexDirection: 'column' }}
        >
          {/* breadcrumb */}
          <Breadcrumbs />
          <Outlet />
          {/* <Footer /> */}
        </Container>
      </MainContentStyled>
      {/* <Customization /> */}
    </Box>
  );
}
